// extracted by mini-css-extract-plugin
export var content = "Section-module--content--6mnx3";
export var dash = "Section-module--dash--XBEb7";
export var title = "Section-module--title--wLWra";
export var wrapper = "Section-module--wrapper--W7OBK";